module.exports = __webpack_public_path__ + "img/hr-assembling-machine-3-pipe-S.3e26a755.png";